export default "__VITE_ASSET__xDmyPILJ__"